export const SOUTH_BUILDING_SOCIETY = {
  LENDER_ID: 53,
  COMMISSION_CAP: 15000,
};
